import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { Flex } from '@react-three/flex';
import { observer } from 'mobx-react-lite';

import { HeroAndTextMoreCta } from './HeroAndTextMoreCta';
import { HeroAndTextParagraph } from './HeroAndTextParagraph';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_HeroAndText_TextPart>;
};

export const ParagraphsColumn = observer(function ParagraphsColumn({
  gridCard,
}: Props) {
  const { data } = gridCard;
  const { paragraphsColumn, paragraphs, cta } = data!.styles!.textPart!;

  const flexPosition: [number, number, number] = [
    paragraphsColumn!.position.x,
    paragraphsColumn!.position.y,
    0,
  ];

  const flexSize: [number, number, number] = [
    paragraphsColumn!.size.width,
    paragraphsColumn!.size.height,
    0,
  ];

  const displayCta = cta?.position === 'moreCta_under_paragraphs';

  return (
    <Flex
      position={flexPosition}
      size={flexSize}
      centerAnchor
      justifyContent='flex-start'
      alignItems='flex-start'
      flexDirection='column'
    >
      {paragraphs!.map((p, index) => {
        const margin =
          index === 0 ? 0 : p.props.lineHeight! * p.props.fontSize!;

        return (
          <HeroAndTextParagraph
            key={p.props.text + index}
            view={p}
            marginTop={margin}
          />
        );
      })}
      {displayCta && <HeroAndTextMoreCta gridCard={gridCard} />}
    </Flex>
  );
});
